import { render, staticRenderFns } from "./GroupCreateEditModal.vue?vue&type=template&id=2e88533c&"
import script from "./GroupCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./GroupCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports